import { createSelector } from "reselect";
import moment from "moment";
import { get } from "lodash";

export const selectWeekCount = ({ WeekPlanner_reducer }) => {
    return WeekPlanner_reducer.weekCount;
};

export const getRequesting  = ({ WeekPlanner_reducer }) => {
    return WeekPlanner_reducer.usersRequesting;
};

export const selectRowCount = ({ WeekPlanner_reducer }) => {
    return WeekPlanner_reducer.rowCount;
};

export const selectEventRows = ({ WeekPlanner_reducer }) => {
    return WeekPlanner_reducer.eventRows;
};

export const selectWeekStart = ({ WeekPlanner_reducer }) => {
    return WeekPlanner_reducer.weekStart;
};

export const selectTemplate = ({ WeekPlanner_reducer }) => {
    return WeekPlanner_reducer.template;
};

export const selectUsers = ({ WeekPlanner_reducer }) => {
    return WeekPlanner_reducer.users;
};

export const selectUserPositions = ({ WeekPlanner_reducer }) => {
    return WeekPlanner_reducer.userPositions;
};

export const selectTempUserPositions = ({ WeekPlanner_reducer }) => {
    return WeekPlanner_reducer.tempUserPositions;
};

export const selectJobpacks = ({ WeekPlanner_reducer }) => {
    return WeekPlanner_reducer.jobpacks;
};

export const selectJobpackKeys = createSelector(
    [selectJobpacks],
    (jobpacks = false) => {
        if (
            jobpacks === false ||
            typeof jobpacks === "undefined" ||
            jobpacks === null
        ) {
            return [];
        }

        return Object.entries(jobpacks).map(([key, value]) => {
            return {
                uid: key,
                client_name: get(value, "profile.client_name") || null
            };
        });
    }
);

export const selectUserNames = createSelector(
    [selectUsers],
    (users = false) => {
        if (users === false) {
            return [];
        }
        const usernames = Object.keys(users)
            .map(e => {
                const first_name = get(users[e], "profile.first_name") || "";
                const last_name = get(users[e], "profile.last_name") || "";

                return `${first_name} ${last_name}`;
            })
            .sort((a, b) => {
                return a.localeCompare(b);
            });

        return [...usernames];
    }
);

export const selectWeekStartKey = createSelector(
    [selectWeekStart],
    weekStart => {
        return moment(weekStart)
            .format("YYYY-MM-DD")
            .toString();
    }
);

export const selectEmployees = createSelector(
    [selectWeekStart, selectWeekCount],
    (weekStart, weekCount) => {}
);
export const selectWeekDayStrings = createSelector(
    [selectWeekStart, selectWeekCount],
    (weekStart, weekCount) => {
        const weekDays = [];

        for (let i = 0; i < weekCount * 7; ++i) {
            const date = moment(weekStart).add(i, "days");
            const dateString = date.format("ddd Do MMM");
            weekDays.push(dateString);
        }

        return weekDays;
    }
);

export const selectDays = createSelector(
    [selectWeekCount, selectEventRows],
    (weekCount, rows) => {
        const days = [];
        for (let row = 0; row < rows.length; ++row) {
            for (let day = 0; day < weekCount * 7; ++day) {
                days.push({
                    day,
                    row
                });
            }
        }

        return days;
    }
);

export const selectTempUserPositionsForDay = day => {
    return createSelector(
        [selectTempUserPositions],
        tempUserPositions => {
            if (
                Array.isArray(tempUserPositions) === true &&
                Number.isInteger(day)
            ) {
                return tempUserPositions[day];
            }
            return false;
        }
    );
};

export const selectNextWeekStart = createSelector(
    [selectWeekStart],
    weekStart => {
        const nextWeekStart = moment(weekStart)
            .add(1, "week")
            .toDate();
        return nextWeekStart;
    }
);

export const selectPreviousWeekStart = createSelector(
    [selectWeekStart],
    weekStart => {
        const previousWeekStart = moment(weekStart)
            .add(-1, "week")
            .toDate();
        return previousWeekStart;
    }
);
